import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '@horizon/core-notifications';
import {
  ContactInformation,
  ContactListData,
  GenesysContactData,
} from '@shared/interfaces/CallLog';
import { ApiExceptionsHandlerService } from '@shared/services/api-exceptions-handler.service';
import { DialerApiService } from '@shared/services/dailer-api.service';
import { BehaviorSubject, catchError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GenesysContactFinder {
  contactDetail: BehaviorSubject<ContactInformation> = new BehaviorSubject(
    null
  );

  constructor(
    private readonly dialerApi: DialerApiService,
    private readonly apiExceptions: ApiExceptionsHandlerService,
    private readonly notificationsService: NotificationService
  ) {}

  findContactInformation(contactListData: ContactListData) {
    const request = this.dialerApi.fetchContactList(contactListData);

    request
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return this.apiExceptions.catchErrorHandler(error, 'dialer');
        })
      )
      .subscribe((response: GenesysContactData) => {
        this.contactDetail.next({ accountNumber: response.accountNumber });
      });
  }

  getContactDetail() {
    return this.contactDetail.asObservable();
  }
}
